/**
 * Per-project client delivery unlock (Stripe one-time $79).
 * Keep list price in sync with functions/src/projectDeliveryUnlock.ts and subscriptionListPricesUsd.js.
 */
export { PROJECT_DELIVERY_UNLOCK_USD } from './subscriptionListPricesUsd';

export function projectDocHasDeliveryUnlock(projectDoc) {
  const block = projectDoc?.deliveryUnlock;
  return block != null && block.unlockedAt != null;
}

/** Branded PDF, portal logo/password, and frame search for this studio project. */
export function canUseBrandedDeliveryForProject(plan, projectDoc) {
  const p = typeof plan === 'string' ? plan.trim().toLowerCase() : 'free';
  if (p === 'enterprise' || p === 'unlimited') return true;
  if (p === 'pro_delivery') return true;
  return projectDocHasDeliveryUnlock(projectDoc);
}
